import React from 'react';
import { 
  Box, 
  Typography, 
  Link
} from '@mui/material';
import { ContentCopy, OpenInNew, Android, PhoneIphone, Computer } from '@mui/icons-material';
import GoogleOtherCalendars from 'src/assets/screenshots/google-other-calendars.png';
import GooglePasteUrl from 'src/assets/screenshots/google-paste-url.png';
import GoogleCalendarUpsell from './GoogleCalendarUpsell.js';


const GoogleFAQs = ({ onCopyLink }) => {
  return [
    {
      question: "I wasn't prompted to add the calendar.",
      answer: (
        <Box>
          <Box sx={{ mb: 2}}>
            <Typography variant="h5" sx={{ mb: 2, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1}}>
              <Android sx={{ fontSize: 20 }} />
              Android
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>
              Android only lets you subscribe to a calendar on the web. You can show or hide calendars you've already subscribed to, but you can't subscribe to a calendar in the Google Calendar app. {" "}
              <Link 
                href="https://support.google.com/calendar/answer/37100?hl=en&co=GENIE.Platform%3DAndroid#:~:text=Important%3A%20You%20can%20only%20subscribe,in%20the%20Google%20Calendar%20app.&text=Check%20or%20uncheck%20your%20preferred%20calendar." 
                target="_blank" 
                rel="noopener noreferrer"
                sx={{ cursor: "pointer", textDecoration: "underline" }}
              >
                (source)
                <OpenInNew sx={{ fontSize: 14, ml: 0.5 }} />
              </Link>
            </Typography>

            <Typography variant="h5" sx={{ mt: 4, mb: 2, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1}}>
              <PhoneIphone sx={{ fontSize: 20 }} />
              iPhone
              <Computer sx={{ fontSize: 20, ml: 1 }} />
              Desktop
            </Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
              <strong>Step 1: </strong>
              <Link onClick={onCopyLink} sx={{ cursor: "pointer", textDecoration: "underline" }}>
                Copy this link 
                <ContentCopy sx={{ fontSize: 14, ml: 0.5 }} />
              </Link>
            </Typography>
            
            <Typography variant="body1" sx={{ lineHeight: 1.5 }}>
              <strong>Step 2: </strong>
              <Link onClick={() => window.open('https://calendar.google.com/calendar/u/0/r/settings/addbyurl', '_blank')} sx={{ cursor: "pointer", textDecoration: "underline" }}>
                Open Google Calendar 
                <OpenInNew sx={{ fontSize: 14, ml: 0.5 }} />
              </Link>
              {" "} and paste the link in the "From URL" box. Click on "Add Calendar" and you're good to go.
              <img 
                src={GooglePasteUrl} 
                alt="Google Calendar From URL dialog"
              />
            </Typography>

            <Typography variant="body1" sx={{ lineHeight: 1.5 }}>
              <strong>Note: </strong>
              If you are not immediately taken to the page to paste in the URL, go to your {" "}
              <Link onClick={() => window.open('https://calendar.google.com/calendar/u/0/r/settings/addbyurl', '_blank')} sx={{ cursor: "pointer", textDecoration: "underline" }}>Google Calendar</Link>
              {" "} and find the Other Calendars Section on the bottom left.
              <br /><br />
              Select <strong>+</strong> and then <b>From URL</b>. 
              <br /><br />
              <img 
                src={GoogleOtherCalendars} 
                alt="Google Calendar From URL dialog"
              />
            </Typography>

            <Typography variant="body1" sx={{ mt: 4, lineHeight: 1.5 }}>
              <strong>Step 3: </strong>
              <Link onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} sx={{ cursor: "pointer", textDecoration: "underline" }}>
              Confirm that everything is working
                </Link>
                {" "}  as expected or {" "}
                <Link onClick={() => window.open(process.env.REACT_APP_SUPPORT_FORM, '_blank')} sx={{ cursor: "pointer", textDecoration: "underline" }}>
                  submit a ticket
                  <OpenInNew sx={{ fontSize: 14, ml: 0.5 }} />
                </Link>
                {" "} if you continue to have issues.
            </Typography>
          </Box>
        </Box>
      )
    },
    {
      question: "I see the calendar in my list of calendars but it shows up as \"webcal://...\"",
      answer: (
        <>
          This is a known issue with Google Calendar taking up to 24 hours to pull events and data for subscriptions (
          <Link 
            href="https://support.google.com/calendar/answer/37100?hl=en#zippy=%2Cadd-a-calendar-by-url" 
            target="_blank" 
            rel="noopener noreferrer"
            sx={{ cursor: "pointer", textDecoration: "underline" }}
          >
            see official Google Calendar post
            <OpenInNew sx={{ fontSize: 14, ml: 0.5 }} />
          </Link>
          ).
          <br /><br />
          <GoogleCalendarUpsell />
        </>
      )
    },
    {
      question: "Events aren't showing up in my Google Calendar.",
      answer: (
        <>
          This is a known issue with Google Calendar taking up to 24 hours to pull events and data for subscriptions (
          <Link 
            href="https://support.google.com/calendar/answer/37100?hl=en#zippy=%2Cadd-a-calendar-by-url" 
            target="_blank" 
            rel="noopener noreferrer"
            sx={{ cursor: "pointer", textDecoration: "underline" }}
          >
            see official Google Calendar post
            <OpenInNew sx={{ fontSize: 14, ml: 0.5 }} />
          </Link>
          ).
          <br /><br />
          <GoogleCalendarUpsell />
        </>
      )
    },
  ];
};

export default GoogleFAQs;